import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import React, { useEffect } from "react";
import Footer from "../Footer";
import Header from "../Header";
import { GeoResult, IServiceLoftLocation } from "../declarations";
import { useGetGeoLocationAddress } from "../hooks/useGetGeoLocationAddress";
import { useBrowserLocation } from "../hooks/useGetBrowserLocation";
import { useGetServiceLofts } from "../hooks/useGetServiceLofts";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";

export default function ServiceLofts() {
    const { state, requestLocation } = useBrowserLocation();

    const { data: reverseGeo } = useGetGeoLocationAddress(
        state.status === "success" ? state.latitude : 0,
        state.status === "success" ? state.longitude : 0,
    );

    const { data: serviceLofts } = useGetServiceLofts(
        state.status === "success" ? state.latitude : 0,
        state.status === "success" ? state.longitude : 0,
    );

    useEffect(() => {
        if (state.status === "idle") {
            requestLocation();
        }
    }, [state]);

    function renderGeoResult() {
        if (state.status === "idle" || state.status === "loading") {
            return <Typography>Getting location...</Typography>;
        } else {
            if (state.status === "success") {
                // return (
                //     <Typography>
                //         Latitude: {state.latitude}, Longitude: {state.longitude}
                //         , Accuracy: {state.accuracyMeters} meters
                //     </Typography>
                // );
            } else {
                switch (state.reason) {
                    case "unsupported":
                        return (
                            <Typography>
                                Geolocation is not supported by your browser.
                            </Typography>
                        );
                    case "denied":
                        return (
                            <Typography>
                                Geolocation permission was denied.
                            </Typography>
                        );
                    case "timeout":
                        return (
                            <Typography>
                                Geolocation request timed out.
                            </Typography>
                        );
                    case "unavailable":
                        return (
                            <Typography>
                                Geolocation is currently unavailable.
                            </Typography>
                        );
                    case "unknown":
                    default:
                        return (
                            <Typography>
                                An unknown error occurred while retrieving
                                geolocation.
                            </Typography>
                        );
                }
            }
        }
    }
    if (!reverseGeo) {
        return <div>Loading...</div>;
    }

    function renderAddress(loft: IServiceLoftLocation) {
        var address = `${loft.addr1 ? `${loft.addr1}` : ""} ${loft.addr2 ? `, ${loft.addr2}` : ""} ${loft.addr3 ? `, ${loft.addr3}` : ""}`;
        return (
            <Typography
                component="p"
                variant="body2"
                gutterBottom={false}
                style={{ whiteSpace: "pre-line", textAlign: "center" }}
            >
                {address}
                {loft.city ? `\n${loft.city}` : ""}
                {loft.state ? `\n${loft.state}` : ""}
                {loft.zip ? `\n${loft.zip}` : ""}
                {loft.country ? `\n${loft.country}` : ""}
            </Typography>
        );
    }

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                minHeight: "100vh",
                justifyContent: "space-between",
            }}
        >
            <Stack
                spacing={3}
                sx={{
                    margin: 2,
                    alignItems: "center",
                }}
            >
                <Header Title="Service Lofts" />
                {renderGeoResult()}
                {state.status === "success" && reverseGeo !== null && (
                    <Typography>
                        {reverseGeo
                            ? `My Location: near ${reverseGeo.address.town}, ${reverseGeo.address.county}, ${reverseGeo.address.state}`
                            : "Loading address..."}
                    </Typography>
                )}
                <Stack spacing={2} sx={{ alignItems: "center" }}>
                    {serviceLofts && serviceLofts.length > 0 ? (
                        serviceLofts.map((loft, index) => (
                            <React.Fragment key={index}>
                                <Card
                                    style={{
                                        // padding: "16px",
                                        minWidth: "300px",
                                        textAlign: "center",
                                    }}
                                >
                                    <CardHeader title={loft.division} />
                                    <CardContent>
                                        {renderAddress(loft)}
                                        {"approx. " +
                                            (loft.distanceKm * 0.671).toFixed(
                                                2,
                                            ) +
                                            " miles"}
                                    </CardContent>
                                </Card>
                                {index === 0 && <Typography>others</Typography>}
                            </React.Fragment>
                        ))
                    ) : (
                        <Typography>No Service Lofts Found</Typography>
                    )}
                </Stack>
            </Stack>
            <Footer />
        </div>
    );
}
